import { registerComponent } from "helpers";
import WYATTElement from "wyatt";

registerComponent(
  "quantity-stepper",
  class QuantityStepper extends WYATTElement {
    constructor() {
      super();

      this.input = this.querySelector("input");
      this.buttons = this.querySelectorAll("button");
      this.changeEvent = new Event("change", { bubbles: true });
      this.checkDisabledState();

      this.buttons.forEach((button) => {
        button.addEventListener("click", this.onButtonClick.bind(this));
      });

      if (this.config.publishEvent) {
        this.boundPublishQuantity = this.publishQuantity.bind(this);
        this.input.addEventListener("change", this.boundPublishQuantity);
        this.input.addEventListener("input", this.boundPublishQuantity);
      }
    }

    disconnectedCallback() {
      if (this.config.publishEvent) {
        this.input?.removeEventListener("change", this.boundPublishQuantity);
        this.input?.removeEventListener("input", this.boundPublishQuantity);
      }

      super.disconnectedCallback();
    }

    onButtonClick(event) {
      const previousValue = parseInt(this.input.value, 10);
      event.preventDefault();

      if (event.currentTarget.name === "plus") {
        this.input.stepUp();
      } else {
        this.input.stepDown();
      }

      const newValue = parseInt(this.input.value, 10);
      if (previousValue !== newValue) {
        this.input.dispatchEvent(this.changeEvent);
      }

      this.checkDisabledState();
    }

    checkDisabledState() {
      const currentQuantity = parseInt(this.input.value, 10);
      const maxQuantity = parseInt(this.input.max, 10);
      const minQuantity = parseInt(this.input.min, 10);

      this.buttons.forEach((button) => {
        if (button.name === "plus") {
          button.disabled = currentQuantity === maxQuantity;
        } else {
          button.disabled = currentQuantity === minQuantity;
        }
      });
    }

    publishQuantity() {
      this.publish(WYATT.PubSub.events.updateQuantity, {
        formId: this.config.formId,
        quantity: Number(this.input.value),
      });
    }
  },
);
